import { render, staticRenderFns } from "./KSlider.vue?vue&type=template&id=503b4e50"
import script from "./KSlider.vue?vue&type=script&lang=js"
export * from "./KSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports